import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zh from './zh.json'
import tw from './tw.json'
import en from './en.json'
import ja from './ja.json'
import ar from './ar.json'
import bn from './bn.json'
import cs from './cs.json'
import de from './de.json'
import el from './el.json'
import es from './es.json'
import fa from './fa.json'
import fr from './fr.json'
import hi from './hi.json'
import hu from './hu.json'
import id from './id.json'
import it from './it.json'
import ko from './ko.json'
import ms from './ms.json'
import my from './my.json'
import nb from './nb.json'
import nl from './nl.json'
import pl from './pl.json'
import pt from './pt.json'
import ro from './ro.json'
import ru from './ru.json'
import sv from './sv.json'
import ta from './ta.json'
import te from './te.json'
import th from './th.json'
import tl from './tl.json'
import tr from './tr.json'
import vi from './vi.json'

Vue.use(VueI18n)

let activeLan = [
    "zh",
    "tw",
    "en",
    "ja",
    "ar",
    "bn",
    "cs",
    "de",
    "el",
    "es",
    "fa",
    "fr",
    "hi",
    "hu",
    "id",
    "it",
    "ko",
    "ms",
    "my",
    "nb",
    "nl",
    "pl",
    "pt",
    "ro",
    "ru",
    "sv",
    "ta",
    "te",
    "th",
    "tl",
    "tr",
    "vi"];

const messages = {
    zh,
    tw,
    en,
    ja,
    ar,
    bn,
    cs,
    de,
    el,
    es,
    fa,
    fr,
    hi,
    hu,
    id,
    it,
    ko,
    ms,
    my,
    nb,
    nl,
    pl,
    pt,
    ro,
    ru,
    sv,
    ta,
    te,
    th,
    tl,
    tr,
    vi
}

let navigatorLanguage = (
    navigator.language || navigator.browserLanguage
).toLowerCase(); //常规浏览器语言和IE浏览器

if (navigatorLanguage.indexOf("zh") > -1 && navigatorLanguage.toLowerCase() === "zh-cn") {
    navigatorLanguage = "zh"
} else if (navigatorLanguage.indexOf("zh") > -1 && navigatorLanguage.toLowerCase() === "zh-tw") {
    navigatorLanguage = "tw"
}

navigatorLanguage = navigatorLanguage.substr(0, 2); //截取lang前2位字符

navigatorLanguage = activeLan.includes(navigatorLanguage)
    ? navigatorLanguage
    : "en";

const i18n = new VueI18n({
    locale: navigatorLanguage,
    silentTranslationWarn: true,
    missing () {//没有key值时应如何处理  
        return "";
    },
    messages
});
export default i18n;